<div class="w-full grid grid-cols-2 lg:grid-cols-3 gap-y-3 md:gap-y-0 md:gap-x-1">
	<a *ngFor="let recommended of blogRecommendedList"
	   class="fb-more-blog-card"
	   target="_blank"
	   [routerLink]="url + recommended.slug + '/'+ recommended.id">
		<img class="fb-tp-news" [src]="recommended.bannerImageMobile"  [alt]="recommended.title" lazyLoad>
		<div class="icon">
			<div class="fb-third-party-header">
				<p>
					{{recommended.title.toLowerCase()}}
				</p>
			</div>
			<div class="text-xs pb-1">Published on {{recommended.timeOfCreation | formatDate}}</div>
			<article [innerHTML]="recommended.description | truncketHtml: 100"></article>
		</div>
	</a>
</div>
